import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

/**
 * Bespoke replacement for `react-loading-overlay`.
 * Every call site in this project already renders its own project-owned
 * backdrop (`.loading-overlay` wrapping div, see src/theme/styles/main.css)
 * and is childless, so this component only needs to show/hide a spinner and
 * a text message in lockstep with `active`.
 */
function LoadingOverlay({
  active, spinner, text, className, fadeSpeed, children,
}) {
  if (!active) {
    return children || null;
  }

  return (
    <div className={className} style={{ transitionDuration: `${fadeSpeed}ms` }}>
      {spinner && (typeof spinner === 'boolean' ? <CircularProgress /> : spinner)}
      {text && <div className="loading-overlay-text">{text}</div>}
      {children}
    </div>
  );
}

LoadingOverlay.propTypes = {
  active: PropTypes.bool,
  spinner: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  text: PropTypes.node,
  className: PropTypes.string,
  fadeSpeed: PropTypes.number,
  children: PropTypes.node,
};

LoadingOverlay.defaultProps = {
  active: false,
  spinner: false,
  text: '',
  className: '',
  fadeSpeed: 500,
  children: null,
};

export default LoadingOverlay;
